import React from 'react'

import { Form } from '@/app/component/form'
import { ActionsContainer, FormContainer } from '@/app/component/form/common'
import SubmitButton from '@/app/component/form/submit-button'
import { useCreateGroup } from '@/app/module/groups/hooks/use-create-group'

import { fields, schema } from './specs'

type Props = {
  onExit: () => void
}

const CreateGroupForm: React.FC<Props> = ({ onExit }) => {
  const [createGroup, { isLoading }] = useCreateGroup()

  const handleSubmit = React.useCallback(
    async (values: { name: string }) => {
      const success = await createGroup({ type: 'NORMAL', name: values.name, description: '', noAutodelete: false })
      if (!success) {
        return
      }
      onExit()
    },
    [createGroup, onExit],
  )

  return (
    <FormContainer>
      <Form
        defaultValues={defaultValues}
        fields={fields}
        name="create-group"
        schema={schema}
        shouldReset
        onSubmit={handleSubmit}
        renderActions={({ isDirty }) => (
          <ActionsContainer>
            <SubmitButton isDirty={isDirty} isSubmitting={isLoading}>
              Save
            </SubmitButton>
          </ActionsContainer>
        )}
      />
    </FormContainer>
  )
}

const defaultValues = {
  name: '',
}

export default CreateGroupForm
